<template>
  <div class="row cart cart-open">
    <div class="col-md-offset-2 col-md-8">

      <h4 class="cart-title text-center">
        {{__t('shop.cart.my_order')}}

      </h4>

      <div class="text-center">
        <a :href="shopInfo ? shopInfo.shopUrl : ''">
          {{__t('shop.cart.continue_shopping')}}
        </a>
      </div>

      <hr>
      <div class="flex flex-wrap" style="flex-direction: row">

        <!-- CART IS EMPTY -->
        <div class="flex justify-center padd30t" style="width:100%" v-if="cart.items.length == 0">
          <span class="center" style="color:gray">
            <i class="far fa-8x fa-shopping-basket"></i>
            <p class="size14">
              {{__t('shop.cart.my_cart')}}
            </p>
          </span>
        </div>

        <!-- DISPLAY CART ITEMS -->
        <div class="w-100" v-for="(cartItem,index) in cart.items">
          <div v-if="cartItem" class="flex justify-between items-center cart-item">
            <div class="flex-1 flex justify-center quantity-controls" style="flex-direction: column">
              <a href="#" @click.prevent="increaseQuantity(index)">
                <span class="item-add">
                  <i class="far fa-plus"></i><span class="sr-only">plus</span>
                </span>
              </a><br>

              <div class="flex items-center">
                <span>
                  {{cartItem.quantity}}
                </span>

                <span class="item-decrease-quantity" v-if="cartItem.quantity > 1" @click="decreaseQuantity(index)">
                  <i class="far fa-minus"></i><span class="sr-only">minus</span>
                </span>
              </div>

            </div>
            <div style="flex:2">
              <span v-if="cartItem.imageUrl">
                <img class="cart-product-image" :src="cartItem.imageUrl" alt="cart-product-image" />
              </span>
            </div>

            <div style="flex:3">
              <a :href="cartItem.uri">
                <span class="cart-product-name">
                  {{cartItem.name}}
                </span>
              </a>
              <br>
              <span v-if="cartItem.variant_values">
                <span class="cart-product-description" v-for="(optionName,groupName) in cartItem.variant_values">
                  <span>
                    {{groupName}}: {{optionName}}
                  </span><br>
                </span>
              </span>
              <span v-if="cartItem.options.length" class="cart-product-description">
                <span class="cart-product-description" v-for="(option,index) in cartItem.options">
                  <span>
                    {{option.group_name}}: {{option.name}}
                  </span><br>
                </span>
              </span>
            </div>
            <div class="flex-1">
              <span v-if="cartItem.total_disc_cost && cartItem.total_disc_cost < cartItem.total_cost">
                <span style="margin-right: 5px">
                  <del>{{(cartItem.total_cost + cartItem.vatAmount).toFixed(2)}} {{currency}}</del>
                </span>
                <span>
                  {{ Number(cartItem.total_disc_cost + cartItem.vatAmount).toFixed(2)}} {{currency}}
                </span>
              </span>
              <span v-else>
                <span v-if="cartItem.vatAmount">
                  {{ Number(cartItem.total_cost + ((cartItem.vatAmount))).toFixed(2)}}
                  {{currency}}
                </span>
                 <span v-else>
                  {{ Number(cartItem.total_cost).toFixed(2)}}
                  {{currency}}
                </span>
              </span>

            </div>
            <div>
              <a href="#" @click="removeItemFromCart(index)">
                <span>
                  <i class="fa fa-trash"></i><span class="sr-only">remove</span>
                </span>
              </a>
            </div>
          </div>
        </div>

        <!-- SUMMARY -->
        <div class="w-100 flex padd30t" style="justify-content: space-around;">
          <span>
            <strong>{{__('webapp.total')}}</strong>:
          </span>
          <span>
            <span v-if="cart.total_discount" style="margin-right: 5px">
              <del>{{ (cart.cart_cost + totalVat).toFixed(2)}} {{currency}}</del>
            </span>
            <span v-if="cart.total_discount < 0">
              <strong>{{ ((cart.cart_after_discount_cost = cart.cart_cost + cart.total_discount) +
                totalVat).toFixed(2)}}
                {{currency}}</strong>
            </span>
            <span v-else>
              <strong>{{ ((cart.cart_after_discount_cost = cart.cart_cost - cart.total_discount) +
                totalVat).toFixed(2)}}
                {{currency}}</strong>
            </span>
          </span>
        </div>

        <!-- CHECKOUT BUTTON -->
        <div class="w-100 flex justify-center padd30t padd30b">

          <div v-if="minimumPurchaseAmountEnabled && minimumPurchaseAmount > 0">
            {{ __('webapp.minimum_purchase_amount') }}: {{ minimumPurchaseAmount.toFixed(2) }}€
          </div>

          <btn @click.prevent="handleCheckoutClicked" :disabled="cart.items.length == 0" class="btn is-btn-primary">
            {{__('webapp.checkout')}}
          </btn>
        </div>

        <!-- CLEAR CART BUTTON -->
        <div class="w-100 center" v-if="cart.items.length">
          <a href="#" class="cart-clear-button" @click="clearCart">
            <span>
              {{__t('shop.cart.clear')}}
            </span>
          </a>
        </div>


      </div>
    </div>
  </div>
</template>

<script>


import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import Btn from '@/components/ui/btn';


export default {
    components: {Btn},
    data: function(){
        return {
          companyAlias: window.company_alias,
          currency: window.currency,
          expandedCartProductIndex: null,
          vatPercentages: [],
          vatCategoryTotals: {},
          vatAmount:null,
        }
    },
    props: {
      minimumPurchaseAmountEnabled: {
        type: Boolean,
        required: true
      },
      minimumPurchaseAmount: {
        type: Number,
        required: true
      },
      b2bEnabled: {
        type: String,
        required: true
      },
      defaultVat: {
        type: Object,
        default: null
      },

   },
    computed:{
      ...mapGetters({cart: 'getCart'}),
      ...mapGetters({shopInfo: 'getShopInfo'}),
      ...mapGetters(['cartTotalCost']),
      totalVat() {
        let totalVat = 0;

        if (this.b2bEnabled) {
          for (const vatCategory in this.vatCategoryTotals) {
            totalVat += this.vatCategoryTotals[vatCategory];
          }
        }
      
        return totalVat;
      }
    },
    methods:{
      route,
      ...mapActions([
        'initCart',
        'fetchShopInfo',
        'increaseQuantity',
        'decreaseQuantity',
        'clearCart',
        'removeItemFromCart'
      ]),
      itemExistsInCart(item){
        // return this.cartItems.findIndex(x => x.item.id == item.id) === -1 ? false: true;
      },
      getCartItem(item){
        // if(!this.itemExistsInCart(item)) return null;

        // return this.cartItems.find(x => x.item.id == item.id);
      },
      handleCheckoutClicked(){
        if(this.cart.items.length > 0){
          $.ajax({
            type: 'POST',
            url: route('webapp.shop.checkout.create',{alias: window.company_alias}),
            data: {},
            success(response){
              console.log(response)
              if(response.hasOwnProperty('redirect')){
                window.location.href = response.redirect;
              }
            },
            error(error){
              console.log(error)
            }
          })
        }
      },
      async fetchVatPercentages() {
        const vatCategoryTotals = {};
        const vatPercentages = [];

        const fetchItemData = async (itemId) => {
          try {
            const response = await $.ajax({
              type: 'GET',
              url: `/companyadmin/shop/items/item/${itemId}`,
              data: {
                company_alias: this.companyAlias,  // Send company ID in the body
              },
            });

            return response.data;
          } catch (error) {
            console.error('Error fetching item data:', error);
            throw error;
          }
        };

        const fetchVatCategory = async (vatCategoryId) => {
          try {
            const response = await $.ajax({
              type: 'GET',
              url: route('webapp.shop.vat_category',  {alias: window.company_alias, vatCategory_id : vatCategoryId }),
            });
            return response;
          } catch (error) {
            console.error('Error fetching VAT category:', error);
            throw error;
          }
        };

        const calculateVatAmount = (quantity, Cost, vatPercentage) => {
          return parseFloat(quantity * Cost) - parseFloat(quantity * Cost) / (1 + vatPercentage / 100);
        };

        for (const cartItem of this.cart.items) {
          const itemId = cartItem.item_id;
          const itemData = await fetchItemData(itemId);
          const vatCategoryId = itemData.vat_category_id;

          let vatPercentage, vatAmount, vatName;

          if (this.b2bEnabled === "true" && !itemData.include_vat) {
            if (vatCategoryId) {
              const vatCategory = await fetchVatCategory(vatCategoryId);
              vatPercentage = vatCategory.percentage;
              vatName = vatCategory.name;
            } else {
              if(this.defaultVat){
                vatPercentage = parseFloat(this.defaultVat.percentage).toFixed(2);
                vatName = this.defaultVat.name;
              }else{
                toastr.error('default vat not selected');
              }
            }

            if (cartItem.discounted_cost !== null) {
              vatAmount = -calculateVatAmount(cartItem.quantity, cartItem.discounted_cost, vatPercentage, cartItem.discounted_cost);
            } else {
              vatAmount = -calculateVatAmount(cartItem.quantity, cartItem.unit_cost, vatPercentage);
            }

            
          } else if (this.b2bEnabled === "false" && itemData.include_vat) {
            if (vatCategoryId) {
              const vatCategory = await fetchVatCategory(vatCategoryId);
              vatPercentage = vatCategory.percentage;
              vatName = vatCategory.name;
            } else {
              if(this.defaultVat){
                vatPercentage = parseFloat(this.defaultVat.percentage).toFixed(2);
                vatName = this.defaultVat.name;
              }else{
                toastr.error('default vat not selected');
              }
            }

            if (cartItem.discounted_cost !== null) {
              vatAmount = calculateVatAmount(cartItem.quantity, cartItem.discounted_cost, vatPercentage, cartItem.discounted_cost);
            } else {
              vatAmount = calculateVatAmount(cartItem.quantity, cartItem.unit_cost, vatPercentage);
            }
            
          } else {
            vatAmount = 0;
          }

          if (vatName) {
            vatCategoryTotals[vatName] = (vatCategoryTotals[vatName] || 0) + vatAmount;
          }

          vatPercentages.push(vatPercentage || null);

          cartItem.vatAmount = parseFloat(vatAmount);
        }

        this.vatCategoryTotals = vatCategoryTotals;
        this.vatPercentages = vatPercentages;
      }
    },
    mounted(){
        this.initCart(this.companyAlias);
        this.fetchShopInfo();
      },
    watch: {
      'cart.items': {
        immediate: true,
        handler(newItems, oldItems) {
          if (newItems.length > 0 && oldItems.length === 0) {
            this.fetchVatPercentages();
          } else {            
            newItems.forEach((newItem, index) => {              
              if (oldItems[index] && newItem.quantity !== oldItems[index].quantity) {               
                this.fetchVatPercentages();
              } else if (!oldItems[index]) {                
                console.warn(`Item at index ${index} is not found in old items array.`);
              }
            });
          }
        },
      },
    },



}
</script>

<style scoped>
  .padd30b{
    padding-bottom:30px;
  }

  .flex{
    display: flex;
  }

   /* CART */
  .cart{
    background: white;
    max-width: unset;
    min-width: unset;
    position: relative;
    padding-top:50px;
  }


.catalog-add-to-cart {
  width: 100%;
  text-align: center;
}


  .cart .delivery-types-container{
    margin-left: 12px;
    margin-right: 12px;
  }

  .cart .cart-top-section{
    padding-bottom: 32px;
  }

  .cart-product-image {
    object-fit: cover;
    width : 70%;
    height: 150px;

  }

   .cart .quantity-controls {
    background: #fff ;
  }

  .cart .cart-title{
    color: #000;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    padding-bottom: 40px;
  }

  .cart .cart-item{
    width: 100%;
    min-width: 100%;
    padding: 10px 15px;
    border-bottom: 1px solid #efefef;
  }

  .cart .cart-item .cart-product-name{
    color:#000;
    /*font-weight: bold*/
  }

 .cart .cart-item .cart-product-description{
    color:#909097;
    /*font-weight: bold*/
  }
  .cart .cart-item .fa-trash{
    color:#000;
  }
  /*END CART */


  .item-add{
    border-radius: 50%;
    border: 1px solid #3b7be9;
    padding: 14px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3b7be9;
  }

  .item-decrease-quantity{
    margin:6px;
    width: 12px;
    height: 12px;
    font-size: 9px;
    border-radius: 50%;
    border: 1px solid #000;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
  }

</style>
